import type { NamedExoticComponent, PropsWithChildren, ReactText, ReactNode } from 'react'
import { memo } from 'react'
import { getIntl, getLocale } from 'umi'
import type { IPlaceholderProps } from '@/components/Placeholder'
import Placeholder from '@/components/Placeholder'

export interface IEmptyProps extends IPlaceholderProps {
  empty?: boolean
  children?: ReactNode
  emptyText?: ReactText | IntlTextType
  btnName?: IntlTextType
  handleClick?: () => void
  className?: string
  childClassName?: string
  wrapperClassName?: string
}

const Empty: NamedExoticComponent<PropsWithChildren<IEmptyProps>> = memo((props) => {
  const intl = getIntl(getLocale())

  const {
    empty,
    children,
    emptyText = intl.messages['Global.empty'],
    childClassName,
    className,
    ...rest
  } = props

  if (empty) return <Placeholder msg={emptyText} {...rest} wrapperClassName={className} />
  return <>{childClassName ? <div className={childClassName}>{children}</div> : children}</>
})

export default Empty
